import BrandingWidget from '../enums/BrandingWidget';
import Branding from './Branding';

/**
 * Parse and return theme css template file
 * @param themeSettings
 * @param themeCss
 * @returns {string|string|ApexChat.Portal.ThemePanel.getSkinData.chatStyle}
 */
const GetSkinTemplate = (themeSettings) => {
    // CHAT-7619 - In case of BETA the ChatPreload handler could be OLD and DomPopup will be new, it could break, adding null check
    if (themeSettings) {

        const chatConfig = JSON.parse(themeSettings);
        if (!chatConfig.poweredBy) {
            // some old themes do not have poweredBy section
            chatConfig.poweredBy = { poweredByFont: '' };
        }
        let skinConfig = {
            container: '', // set empty the <#=container#> property
            rdChat: chatConfig,
            global: {}
        };
        const brandingInfo = chatConfig.branding || {};
        if (brandingInfo.brandingIsEnabled) {
            skinConfig.global = { branding: brandingInfo };
            skinConfig = new Branding()
                .init({
                    widget: BrandingWidget.RD_DOM,
                    brandConfig: skinConfig
                })
                .getBrandedConfig();
        }
        return skinConfig;
    }
    // CHAT-7619 - ::TODO:: The 'ELSE' part will be removed, Its added for backword compatiblity (in case of BETA Testing)
};
export default GetSkinTemplate;
